class CountDown extends HTMLElement  {
  constructor(){
    super();
    this.countDownElement = this.querySelector(".count-down")
  }

  currentDate(){
    return new Date().getTime();
  }

  getCurrentHours(){
    return new Date().getHours();
  }
  
  getDistance(){
    return this.countDownDate - this.currentDate();
  }

  getCountdownHours(){
    return  Math.floor((this.getDistance() % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  }
  getCountdownMinutes(){
    return Math.floor((this.getDistance() % (1000 * 60 * 60)) / (1000 * 60));
  }
  getCountdownSeconds(){
    return Math.floor((this.getDistance() % (1000 * 60)) / 1000);
  }

  hide(){
    this.style.display = "none";
  }

  init (){
    const countDown = setInterval(()=>{
      this.countDownElement.innerHTML = ` <span>${this.getCountdownHours()} </span>hours  &nbsp|&nbsp
      <span>${this.getCountdownMinutes()}</span>  minutes &nbsp|&nbsp  <span>${this.getCountdownSeconds()}</span> seconds`;
    if (this.getDistance() < 0) {
          clearInterval(countDown);
          this.hide();
        }
    }, 1000)
  }


}
class CountDownToday extends CountDown{
  constructor(){
    super()
    this.countDownDate = new Date(`${+new Date().getMonth()+1} ${+new Date().getDate()}, ${new Date().getFullYear()} 12:00:00`).getTime();
  }
  connectedCallback(){
    if ( this.getCurrentHours() < 12) {
      this.init()
    } else {
      this.hide()
    }
  }
  disconnectedCallback(){
    this.init()
  }
}
class CountDownTomorrow extends CountDown{
  constructor(){
    super()
    this.countDownDate = new Date(`${+new Date().getMonth()+1} ${+new Date().getDate()}, ${new Date().getFullYear()} 14:00:00`).getTime();
    
  }
  connectedCallback(){
    console.log("this.getCurrentHours()",this.getCurrentHours())
    if ( this.getCurrentHours() < 14) {
      this.init()
    } else {
      this.hide()
    }
  }
  disconnectedCallback(){
    this.init()
  }
}

document.querySelector("count-down") && customElements.define("count-down", CountDownToday)
document.querySelector("count-down-tomorrow") && customElements.define("count-down-tomorrow", CountDownTomorrow)